export default __webpack_public_path__ + "static/media/learn-more-card-6.af4d7677.svg";